export default "__VITE_ASSET__CZJWr1$f__"